import React from 'react'
import PropTypes from 'prop-types'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import withStyles from '@material-ui/core/styles/withStyles'
import Table from '@ui/Table'

import indexStyles from '@styles/indexPage'

const formatChanges = changes =>
  Object.entries(changes || {})
    .map(([field, values]) => `${field}: ${values[0] === null ? '—' : values[0]} → ${values[1] === null ? '—' : values[1]}`)
    .join(' | ')

const Audits = ({ model, classes, o }) => (
  <Paper className={classes.page__wrapper} elevation={0}>
    <header className={classes.page__header}>
      <Typography component='h2' variant='h5'>
        {I18n.t('v4/equipment_measures.audits.title')}
      </Typography>
    </header>

    <Table
      tableKey='admin-equipmentMeasures-audits'
      components={{
        Container: props => <div>{props.children}</div>
      }}
      columns={[
        { title: I18n.t('v4/equipment_measures.audits.when'), field: 'created_at' },
        { title: I18n.t('v4/equipment_measures.audits.user'), field: 'user' },
        {
          title: I18n.t('v4/equipment_measures.audits.equipment'),
          field: 'equipment_id',
          render: rowData => rowData.equipment_id
            ? (rowData.equipment_name ? `${rowData.equipment_id} — ${rowData.equipment_name}` : `${rowData.equipment_id}`)
            : '—'
        },
        { title: I18n.t('v4/equipment_measures.audits.event'), field: 'event' },
        { title: I18n.t('v4/equipment_measures.audits.measure'), field: 'measure_id' },
        {
          title: I18n.t('v4/equipment_measures.audits.changes'),
          field: 'changes',
          render: rowData => formatChanges(rowData.changes)
        },
        { title: I18n.t('v4/equipment_measures.audits.justification'), field: 'justification' }
      ]}
      data={model.audits}
      options={{
        showTitle: false
      }}
    />

    <footer className={classes.footer}>
      <Button
        variant='outlined'
        color='primary'
        href={`/v4/o/${o}/admin/equipment_measures`}
      >
        {I18n.t('v4/equipment_measures.audits.back')}
      </Button>
    </footer>
  </Paper>
)

Audits.propTypes = {
  model: PropTypes.shape({
    audits: PropTypes.array
  })
}

Audits.defaultProps = {
  model: { audits: [] }
}

const Styles = theme => ({
  ...indexStyles(theme),
  footer: {
    marginTop: theme.spacing.unit * 3
  }
})

export default withStyles(Styles)(Audits)
